export const environment = {
    production: false
}

export const version = '4.5.7'
export const releaseNotes =
    'https://drive.google.com/file/d/1cUKoi57APX6K5MNsbYnx-ydthE_AmurF/view?usp=sharing'

export const apis = {
    baseUrl: 'https://rgv4dev.repairgenie.net/backend/api/v4',
    googleApiKey: '',
    googleCaptchaSiteKey: ''
}

export const socialLoginUrls = {
    google: `${apis.baseUrl}/public/login/google`,
    facebook: `${apis.baseUrl}/public/login/facebook`
}

export const firebaseConfig = {
    apiKey: 'AIzaSyCynMycY57mzKOTq2sWYbrcrog8wIpIAHc',
    authDomain: 'rgv4-dev.firebaseapp.com',
    projectId: 'rgv4-dev',
    storageBucket: 'rgv4-dev.appspot.com',
    messagingSenderId: '671556903383',
    appId: '1:671556903383:web:7a628666a8cc1fd1112b92',
    measurementId: 'G-ESPNVXQCNQ',
    vapidKey:
        'BBVOLGfqCFkbJiPgPoWkRoodz0YtYqbJJEOAtJSVU37Lmgh4_Ick7sTcvXP4fcWsc9Vg4pHh4tYQ0k0YtxZQYU8'
}

export const appURL = 'https://rgv4dev.repairgenie.net/'

/**
 * Reverb (Laravel websockets) used for realtime notifications, e.g. "your export is ready".
 * `key` must match REVERB_APP_KEY of the API. While disabled (or unreachable) the app falls
 * back to polling, so a missing Reverb deployment degrades gracefully.
 */
export const reverb = {
    enabled: true,
    key: 'rg4-local-key',
    // Same server as apis.baseUrl above: nginx proxies wss://<host>/app/... to Reverb.
    host: 'rgv4dev.repairgenie.net',
    port: 443,
    forceTLS: true
}
